// MessageDetails.js
import { useEffect, useRef, useState } from 'react';
import axios from 'axios';

const MessageDetails = ({ gaonSrNo, curtab }) => {
  const [messages, setMessages] = useState([]);
  const [error, setError] = useState(null);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const bottomRef = useRef(null);
  const scrollContainerRef = useRef(null);
  const LIMIT = 10;

  const fetchMessages = (newOffset = 0, prepend = false) => {
    axios
      .get('https://mazagaon.co.in/api/get-user-messages.php', {
        params: {
          gaon_Sr_No: gaonSrNo,
          msg_tab: curtab,
          limit: LIMIT,
          offset: newOffset,
        },
      })
      .then((response) => {
        const newMessages = response.data || [];

        if (newMessages.length < LIMIT) setHasMore(false);

        if (prepend) {
          const container = scrollContainerRef.current;
          const scrollHeightBefore = container.scrollHeight;

          setMessages((prev) => [...prev, ...newMessages]);

          // Maintain scroll position after render
          setTimeout(() => {
            const scrollHeightAfter = container.scrollHeight;
            container.scrollTop += scrollHeightAfter - scrollHeightBefore;
          }, 100);
        } else {
          setMessages(newMessages);
          setTimeout(() => {
            bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
          }, 300);
        }

        setOffset(newOffset + LIMIT);
      })
      .catch((err) => {
        console.error('❌ Error fetching messages:', err);
        setError('डेटा मिळवण्यात अडचण आली');
      });
  };

  const handleWhatsAppShare = (message) => {
    const imageUrl = `https://mazagaon.co.in/${message.gaon_name}/img/${curtab}/${message.msg_pic}`;
    const weburl =`www.mazagaon.co.in/${message.gaon_name}`;
    const msgText = `${message.msg_heading}\n\n${message.msg_details}\n\n📸 ${imageUrl}\n\n संपूर्ण माहिती साठी : ${weburl} `;
    const encodedText = encodeURIComponent(msgText);
    const whatsappUrl = `https://wa.me/?text=${encodedText}`;
    window.open(whatsappUrl, '_blank');
  };

  useEffect(() => {
    // Reset when gaon/tab changes
    setMessages([]);
    setOffset(0);
    setHasMore(true);
    fetchMessages(0, false);
  }, [gaonSrNo, curtab]);

  if (error) return <div className="panel error">{error}</div>;
  // if (!messages || messages.length === 0) return <div className="panel">डेटा उपलब्ध नाही.</div>;

  return (
    <div className="panel" ref={scrollContainerRef} style={{ maxHeight: '80vh', overflowY: 'auto', paddingTop:0 }}>
      <div className="container my-1">
        <div className="row g-4">
          <div className="col-12">
            {curtab === 'abhiman' && <h5 className="card-title">🙏🏼 गांवाचा अभिमान</h5>}
            {curtab === 'events' && <h5 className="card-title">🎉 समारंभ</h5>}
            {curtab === 'programs' && <h5 className="card-title">📺 शासकीय उपक्रम</h5>}
            {curtab === 'newprograms' && <h5 className="card-title">🦸🏼 नाविन्यपूर्ण उपक्रम</h5>}
            {curtab === 'schemes' && <h5 className="card-title">📆 योजना</h5>}
          </div>

          {/* 🔼 Load older button */}
          {hasMore && (
            <div className="col-12 text-center">
              <button
                className="btn btn-outline-primary"
                onClick={() => fetchMessages(offset, true)}
              >
                जुने मेसेजेस ⬆️
              </button>
            </div>
          )}

          {/* 📬 Messages (oldest to newest) */}
          {[...messages].reverse().map((message, idx) => (
            <div className="col-md-6 col-12 fade-mobile" key={idx}>
              <div className="card shadow">
                <div className="card-body">
                  <h5 className="card-title">{message.msg_heading}</h5>
                  {message.msg_pic && (
                    <div className="mb-3 w-100" style={{ background: '#eee' }}>
                      <img
                        src={`https://mazagaon.co.in/${message.gaon_name}/img/${curtab}/${message.msg_pic}`}
                        alt={message.msg_heading}
                        className="img-fluid rounded"
                        style={{ width: '100%', objectFit: 'cover' }}
                      />
                    </div>
                  )}
                  <div className="mb-0" style={{ whiteSpace: 'pre-line' }}>
                    {message.msg_details}
                  </div>
                  <p className='msgdatetime my-0'>
                    {new Date(message.msg_dt).toLocaleString('en-IN', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                      hour12: true,
                    })}
                  </p>
                    <div
                    className='sharemessage'
                    style={{ cursor: 'pointer', fontSize: '1.5rem' }}
                    onClick={() => handleWhatsAppShare(message)}
                    title="व्हॉट्सअ‍ॅप वर शेअर करा"
                  >
                    ⤴️
                  </div>

                </div>
              </div>
            </div>
          ))}

          <div ref={bottomRef} />
        </div>
      </div>
    </div>
  );
};

export default MessageDetails;
